// Copied from payment-method-component-redesign.tsx in CDK

import { TextInputStateColorMap } from "@common";

// This is custom CSS that will be passed into the payabli component as a string

export const customCssStyle = `

@import url('https://fonts.googleapis.com/css2?family=Mona+Sans:ital,wght@0,200..900;1,200..900&family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap');

:root {
  --primary-color: #333;
  --secondary-color: #f5f5f5;
  --border-radius: 8px;
}

.payabliPaymentForm {
  font-family: "Mona Sans", sans-serif;
}

.fullw-440 > div,
.col-6 > div,
.col-4 > div,
.mb-3 > div {
  position: relative;
}

label {
  position: absolute;
  font-size: 16px;
  transform-origin: top left;
  transform: translate(16px, 16px) scale(1);
  color: ${TextInputStateColorMap.label.color};
  transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
  pointer-events: none;
  padding: 0;
}

.fullw-440 > div:has(input:focus) label,
.fullw-440 > div:has(input:not(:placeholder-shown)) label,
.fullw-440 > div:has(select:focus) label,
.fullw-440 > div:has(select option:checked) label {
  transform: translate(16px, 8px) scale(0.75);
}

input.form-control {
  width: 100%;
  padding: 24px 16px 8px!important;
  border-radius: var(--border-radius, 8px);
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
  border: 1px solid ${TextInputStateColorMap.default.borderColor};
  color: ${TextInputStateColorMap.default.color};
  background: white;
}

.form-select {
  font-size: 16px!important;
  padding: 24px 16px 8px!important;
  border-radius: var(--border-radius, 8px);
}

.form-control {
  height: 56px;
}

input.form-control::placeholder {
  color: transparent;
}

input.form-control:focus,
select.form-control:focus {
  border-color: ${TextInputStateColorMap.active.borderColor};
  color: ${TextInputStateColorMap.default.color};
  box-shadow: none;
}

input.form-control.input-cc {
  background-repeat: no-repeat;
  background-position: right 16px center !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 0 0 16px 0;
  padding: 0;
}

.row > * {
  margin: 0;
  padding: 0;
}

#cardExpirationDateContainer,
#cardCvvContainer,
#cardZipcodeContainer {
  width: calc((100% - 16px) / 2);
}

#achRouting,
#achAccount {
  margin-bottom: 16px;
}

.mt-3 {
  margin-top: 0!important;
}
.mb-3 {
  margin-bottom: 0!important;
}

.fullw-440 {
  width: 100%;
}

.form-control {
  width: 100%;
}

input:disabled {
  border-color: ${TextInputStateColorMap.disabled.borderColor}!important;
  background-color: ${TextInputStateColorMap.disabled.backgroundColor}!important;
  color: ${TextInputStateColorMap.disabled.color}!important;
}

input:hover:not(.component-input-error)
 {
  border-color: ${TextInputStateColorMap.hover.borderColor}!important;
}

.errorMessageComponent {
  padding-left: 16px;
  margin-top: 3px;
  color: ${TextInputStateColorMap.error.color};
}

`;

// Export the CSS as a data URI for use in iframe src or link href
export const customCssUrl = `data:text/css;charset=utf-8,${encodeURIComponent(customCssStyle)}`;
